$(document).ready(function(){

  //grid icon cross
  $('.cross-icon').click(function(){
    $(this).closest('.grid__item').find('.grid-product__meta').addClass('active');
  })

  $('.close-meta').click(function(){
    $(this).closest('.grid__item').find('.grid-product__meta').removeClass('active');
  })
  
  //homepage swapper
  $('.collection-swapper-container a').click(function(e){
    
    e.preventDefault();
    let el = '#' + $(this).data('collection');
    let bel = '#button-' + $(this).data('collection');

    
    $('.collection-swapper-container a').removeClass('active');
    $('.view-collection-button').removeClass('active');
    
    $(this).addClass('active');
    $(bel).addClass('active');
    
    $('.swapper').removeClass('active');
    $(el).addClass('active');
  })


 //box designer function
 //function to check if text is overflowing

  //delete the zoom button
  if($('#inbox-designer').length > 0){
    $('.js-photoswipe__zoom').remove();
 
  }
  
  function scrollToBoxDesigner(){
      let offset = 100; // No offset by default. Add an offset value if needed.
      $('html, body').animate({
        scrollTop: $('#inbox-designer').offset().top - offset
      }, 1000, 'swing'); // Smooth scroll with 'swing' easing

      $('#designer-box-thumb').click();
  }  

  function isOverflowing(element, text) {
   if(text.clientWidth > element.clientWidth) {
     return true;
   } else { 
     return false;
    }
  }

  //function to check if box is less than 60% of the container
  function isSmallerThanThreshold(element,text) {
    if ((text.clientWidth / element.clientWidth) < .6) {
      return true;
    } else {
      return false;
    }
  }

  function checkTextSize(inputText){

    //click the first thumbnail
    $('.product__thumb-item').first().click();
    
    //get the Current Font Size
    let currentFontSize = $('#designer-text').data('font-size'); 
    
    //enter the text before measuring
    textDiv.textContent = inputText;
    
    let doesTextFit = false;
    let textBoxWidth = displayDiv.clientWidth;
    let designerTextFontWidth = textDiv.clientWidth;

    //enter in the custom option area
    $('#box-gamer-tag').val(inputText);
    
    while(doesTextFit == false){
      //run the check on both and set the variable
      let x = isOverflowing(displayDiv, textDiv);
      let y = isSmallerThanThreshold(displayDiv, textDiv);

      //check if text is overflowing and set values
      if(x == true){
        if(currentFontSize >= .1 ){
         currentFontSize -= .1; // Decrease font size by 1rem
         $('#designer-text').attr('data-font-size', currentFontSize);
         textDiv.style.fontSize = currentFontSize + 'rem';
        }
      } 

      if(window.innerWidth > 1000){
        //check if y is smaller than threshold 
        if(y == true && currentFontSize <= 6){
            currentFontSize += .5; 
            $('#designer-text').attr('data-font-size', currentFontSize);
            textDiv.style.fontSize = currentFontSize + 'rem';      
        } else {
          if(x == false){
            doesTextFit = true;
          }
        }
      } else if(window.innerWidth <= 1000) {
     
        if(y == true && currentFontSize <= 6){
          currentFontSize += .5; 
          $('#designer-text').attr('data-font-size', currentFontSize);
          textDiv.style.fontSize = currentFontSize + 'rem';      
        } else {
          if(x == false){
          doesTextFit = true;
          }
        }
      }
  
      //if both conditions are false, set the variable to true and break the loop
      if(x == false && y == false) {
        doesTextFit = true;     
      }      
    }
  }

  //scroll to the box designer on cllick
  $('#name-text').click(function(){
    //scroll to box designer
    scrollToBoxDesigner();
  })

  //set the variables 
  var inputField = document.getElementById('name-text');
  var textDiv = document.getElementById('designer-text'); 
  var displayDiv = document.getElementById('text-box'); 

  //listen to the textbox and input the values
  inputField.addEventListener('input', function() {
    //grab the input text
    const enteredText = this.value; 
    
    //run the function
    checkTextSize(enteredText);

    //select the first slider
    $('.product__thumb-item').first().click();
  });

  //change the text when clicked on the Designer
  $('.font-choice').on('click', function() {
    
    // Add any font switching logic here using the active font choice:
    var selectedFont = $(this).data('font-type'); 

    //remove all the classes
    $("#designer-text").removeClass();
    $("#designer-text").addClass(selectedFont);
    
    // Remove active class from all font choices
    $('.font-choice').removeClass('active');
    
    // Add active class to the clicked element
    $(this).addClass('active'); 

    //grab the selector from the dropdown
   
    $('#box-font').val(selectedFont);
  
    // Trigger the 'change' event (if necessary):
    $('#box-font').change(); 

    //grab input text 
    const currentText =  inputField.value 
  
    //run the function
    checkTextSize(currentText);

    //scroll to box designer
    scrollToBoxDesigner();

    //grab the first product can click
    $('.product__thumb-item').first().click();
  });

  //on window resize, adjust the font size
  window.addEventListener('resize', function(event){
     const currentText =  inputField.value 
     checkTextSize(currentText);
  });

  $('.close-designer').click(function(){
      $('#inbox-designer').removeClass('active');
  });
            
});